import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from '../../features/external-api/redux/actions';
import ExternalApiHeaderNav from './ExternalApiHeaderNav';
import CommonPageComponent from '../../common/ui/CommonPageComponent';
import ExternalApiList from './ExternalApiList';
import { SUPABASE } from 'drapcode-constant';
import { checkExternalAPIPermission } from '../../common/utils/permissions';
import PermissionDenied from '../../common/PermissionDenied';
export class Supabase extends Component {
  static propTypes = {
    externalApi: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired,
  };
  state = { page: 0, searchTerm: '', limit: 25, headers: [] };
  componentDidMount = async () => {
    const { match, actions, home } = this.props;
    const { projectId, version } = match.params;
    await actions.loadCollections({ projectId, version });
    await actions.loadExternalApis({
      projectId,
      version,
      page: this.state.page,
      externalApiType: SUPABASE,
      limit: this.state.limit,
    });
    const externalapi = await actions.loadExternalDatabase({ projectId, version });
    if (externalapi) {
      const dataTypes = [...new Set(externalapi.map((item) => item.type))];
      console.log('🚀 ~ Supabase ~ componentDidMount= ~ dataTypes:', dataTypes);
      this.setState({ headers: dataTypes });
    }
  };
  render() {
    const isAllowed = checkExternalAPIPermission();
    if (!isAllowed) {
      return <PermissionDenied message="Supabase" />;
    }
    const { match } = this.props;
    const { projectId, version } = match.params;
    const { headers } = this.state;
    console.log('🚀 ~ Supabase ~ render ~ headers:', headers);
    // console.log('HEADERS LINE35', headers);
    return (
      <CommonPageComponent>
        <ExternalApiHeaderNav
          activeTab={SUPABASE}
          projectId={projectId}
          headers={headers}
          version={version}
        />
        <ExternalApiList projectId={projectId} activeTab={SUPABASE} version={version} />
      </CommonPageComponent>
    );
  }
}

function mapStateToProps(state) {
  return {
    externalApi: state.externalapi,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions }, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(Supabase);
